/**
 * Created by Pasquale Tritella on 22/04/2024
 *
 * @format
 */


/**
 * Recupera i dati anagrafici del contribuente autenticato.
 * Endpoint backend: GET /contribuente/<comune> — ritorna { contribuente: {...campi for_api...} }.
 * I campi disponibili (rcweb.anagrafica for_api) sono: codicefiscale, cognome, nome,
 * datanascita, luogonascita, prnascita, indirizzo, civico, esponente, scala, interno,
 * cap, comune, pr, nazione, telefono, email, pec.
 *
 * @param {string} [codicefiscale] CF del contribuente (l'endpoint lo usa per il lookup)
 * @returns {Promise<Object|null>} il record contribuente, o null
 */
const getCustomer = (codicefiscale) => {
    const hash = localStorage.getItem('hash');
    if (hash === null) {
        console.error("NO_AUTH");
        return Promise.reject("NO_AUTH");
    }
    const sep = window.route.customer.includes('?') ? '&' : '?';
    const url = codicefiscale
        ? `${window.route.customer}${sep}codicefiscale=${encodeURIComponent(codicefiscale)}`
        : window.route.customer;

    return fetch(url, { method: 'GET', headers: { 'x-access-token': hash } })
        .then((response) => response.json())
        .then((data) => (data && data.contribuente) ? data.contribuente : null)
        .catch((error) => { console.error(error); return null; });
}

const CustomerAPI = {
    getCustomer: getCustomer
};

export default CustomerAPI;
